import $ from '../tools/Dom';
import Viewport from '../tools/Viewport';

export default (el, data) => {
    const dom = $(el);
    const words = data.words;
    const word = dom.find('[data-word]');
    let interval;
    let container;
    let holder;

    const shuffleWord = () => {
        if (Viewport.visible(el)) {
            holder.html(words[0]);
            words.push(words.shift());
            TweenMax.set(holder.get(0), { x: 50, opacity: 0 });
            TweenMax.to(container.get(0), 0.3, { x: -50, opacity: 0 });
            TweenMax.to(holder.get(0), 0.8, { delay: 0.15, ease: Quint.easeOut, x: 0, opacity: 1, onComplete: () => {
                container.html(holder.html());
                holder.html('');
                TweenMax.set(holder.get(0), { clearProps: 'all' });
                TweenMax.set(container.get(0), { clearProps: 'all' });
            } });
        }
    };

    const setup = () => {
        interval = setInterval(shuffleWord, 4000);
    };

    const kill = () => {
        clearInterval(interval);
    };

    const init = () => {
        word.append('<span class="l-block l-pos-abs l-fill" data-container></span><span class="l-block l-pos-abs l-fill" data-holder></span>');
        container = dom.find('[data-container]');
        holder = dom.find('[data-holder]');
        container.html(words[0]);
        words.push(words.shift());
        setup();
    };

    const destroy = () => {
        kill();
    };

    return {
        init,
        destroy
    };
};
